import React from 'react';

const DesignImages = () => (
  <section
    className="container"
    style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}
  >
    <div className="col-ms-3 col-xs-6">
      <img
        style={{ maxHeight: 340 }}
        className="img-responsive"
        src="/images/design-1.jpg"
        alt=""
      />
    </div>

    <div className="col-ms-3 col-xs-6">
      <img
        style={{ maxHeight: 340 }}
        className="img-responsive"
        src="/images/design-2.jpg"
        alt=""
      />
    </div>
    <div className="col-ms-3 hidden-xs">
      <img
        style={{ maxHeight: 340 }}
        className="img-responsive"
        src="/images/design-3.jpg"
        alt=""
      />
    </div>
  </section>
);

export default DesignImages;
